'use strict';

(function ($, Drupal) {
  Drupal.behaviors.Main = {
    attach: function attach() {
      /* Check for anchors without a target and remove default action */
      var anchors = $('a[href=""]');
      $.each(anchors, function (u, v) {
        $(v).click(function (e) {
          e.preventDefault();
        });
      });

      /* Hide Feature for url */
      if (window.location.href.toLowerCase().indexOf('products/manufacturing-analytics') > -1) {
        $('.pcat-capabilities-li').hide();
      }
      if (window.location.href.toLowerCase().indexOf('/enterprise-resource-planning-capterra') > -1 || window.location.href.toLowerCase().indexOf('/manufacturing-execution-system-capterra') > -1 || window.location.href.toLowerCase().indexOf('/quality-management-system-capterra') > -1 || window.location.href.toLowerCase().indexOf('/supply-chain-planning-capterra') > -1 || window.location.href.toLowerCase().indexOf('/enterprise-resource-planning-capterra') > -1) {
        $('.header-right, .header-top').remove();
        $('#header').css('height', '89px');
      }

      /* Blog checking page */
      if (window.location.href.toLowerCase().indexOf('blog?items_per_page') > -1) {
        $('body').addClass('blog-pages');
      }
      setTimeout(function () {
        var vidButtonText = $('.js-vid-button-text').val();
        $('.play-button').attr('data-btn-text', vidButtonText);
      }, 4000);

      /* CLICK WORKING */

      setTimeout(function () {
        $('.js-company-industry li').click(function (e) {
          // console.log("IN FUCNTION");
          e.preventDefault();
          var value = $(this).attr('data-type-industry-target');
          // console.log(value);

          var pos = $("[data-type-industry=".concat(value, "]")).offset().top - 100;
          $('body, html').animate({
            scrollTop: pos
          });
          $('.js-company-industry li').removeClass('active');
          $(this).addClass('active');
          $('.js-company-industry ul').hide();
          $('.js-company-industry').children('h4').html($(this).html());
        });
      }, 1000);

      /* Resources Filters for the resrouces page */
      setTimeout(function () {
        $('#block-resourceindustryaggregatedfield').children('div').children('div').children('ul').children('li:first-child').children('input').attr('id', 'industry-show-all');
        $('#block-resourceindustryaggregatedfield').children('div').children('div').children('ul').children('li:first-child').children('label').attr('for', 'industry-show-all');
        $('#block-resourcetypeaggregatedfield').children('div').children('div').children('ul').children('li:first-child').children('input').attr('id', 'resource-type-show-all');
        $('#block-resourcetypeaggregatedfield').children('div').children('div').children('ul').children('li:first-child').children('label').attr('for', 'resource-type-show-all');
        $('#block-salesresourcetypeaggregatedfield').children('div').children('div').children('ul').children('li:first-child').children('input').attr('id', 'salesresource-type-show-all');
        $('#block-salesresourcetypeaggregatedfield').children('div').children('div').children('ul').children('li:first-child').children('label').attr('for', 'salesresource-type-show-all');
      }, 2000);

      /* NOT SURE ABOUT THIS FUNCTION */
      var countoverlap = 1;
      $('.half-content-in-white-and-half-in-black-overlapping').each(function () {
        if (countoverlap % 2 === 0) {
          $(this).addClass('even-block');
        }
        $(this).children('.contentWrapper-1290').children('.white-box').children('.number').html(countoverlap.toString());
        countoverlap += 1;
        if ($(this)[0] === $('.half-content-in-white-and-half-in-black-overlapping').last()[0]) {
          $(this).addClass('last-block');
        }
      });

      /* Categary click in blog page and some other pages in tablet and mobile */
      $('.categary-list h4').click(function () {
        var windowsize = $(window).width();
        if (windowsize < 981) {
          if ($(this).parent('.categary-list').children('div').css('display') === 'none') {
            $(this).parent('.categary-list').children('div').slideDown();
            $(this).parent('.categary-list').addClass('active');
          } else {
            $(this).parent('.categary-list').children('div').slideUp();
            $(this).parent('.categary-list').removeClass('active');
          }
        }
      });
      /* Categary click in blog page and some other pages in tablet and mobile  */
      $('.full-width-categary h4').click(function () {
        if ($(this).parent('.contentWrapper-1080').children('ul').css('display') === 'none') {
          $(this).parent('.contentWrapper-1080').children('ul').slideDown();
          $(this).parent('.contentWrapper-1080').parent('.full-width-categary').addClass('active');
        } else {
          $(this).parent('.contentWrapper-1080').children('ul').slideUp();
          $(this).parent('.contentWrapper-1080').parent('.full-width-categary').removeClass('active');
        }
      });
      /* PARTNER FILTER LIST */
      /* Is this being used? */
      $('.parter-categary h4').click(function () {
        if ($(this).parent('.contentWrapper-1290').children('ul').css('display') === 'none') {
          $(this).parent('.contentWrapper-1290').children('ul').slideDown();
          $(this).parent('.contentWrapper-1290').parent('.parter-categary').addClass('active');
        } else {
          $(this).parent('.contentWrapper-1290').children('ul').slideUp();
          $(this).parent('.contentWrapper-1290').parent('.parter-categary').removeClass('active');
        }
      });
      /* NEED MORE INFORMATION */
      $('.choose-option h4').click(function () {
        if ($(this).parent('.choose-option').children('ul').css('display') === 'none') {
          $(this).parent('.choose-option').children('ul').slideDown();
          $(this).parent('.choose-option').addClass('active');
        } else {
          $(this).parent('.choose-option').children('ul').slideUp();
          $(this).parent('.choose-option').removeClass('active');
        }
      });
      /* Accrodian click working */
      $('.accordian h3').click(function () {
        if ($(this).parent('.accordianContentOuter').parent('li').children('.accordianContentOuter').children('.accordianContent').css('display') === 'none') {
          var scrollType = $(this).closest('.accordian').children('.js-accordianScrollType').val();
          var bLazy = new Blazy({
            selector: 'img',
            container: '#frame1'
          });
          $('.accordian li').removeClass('active');
          $('.accordian li').children('.accordianContentOuter').children('.accordianContent').slideUp();
          $(this).parent('.accordianContentOuter').parent('li').children('.accordianContentOuter').children('.accordianContent').slideDown();
          $(this).parent('.accordianContentOuter').parent('li').addClass('active');
          $('.left-accordion-with-content-and-image .image-section').html($(this).parent('.accordianContentOuter').parent('li').children('.js-accordian-img').children('article').html());
          if (scrollType !== 'Off') {
            var accordianHead = $(this);
            setTimeout(function () {
              var pos = accordianHead.offset().top - 110;
              $('body, html').animate({
                scrollTop: pos
              });
            }, 500);
          }
        } else {
          $('.accordian li').removeClass('active');
          $('.accordian li').children('.accordianContentOuter').children('.accordianContent').slideUp();
          $(this).parent('.accordianContentOuter').parent('li').children('.accordianContentOuter').children('.accordianContent').slideUp();
          $(this).parent('.accordianContentOuter').parent('li').removeClass('active');
        }
      });
      /* Accrodian arrow click working */
      $('.accordian .arrow').click(function () {
        var scrollType = $(this).closest('.accordian').children('.js-accordianScrollType').val();
        if ($(this).parent('li').children('.accordianContentOuter').children('.accordianContent').css('display') === 'none') {
          $('.accordian li').removeClass('active');
          $('.accordian li').children('.accordianContentOuter').children('.accordianContent').slideUp();
          $(this).parent('li').children('.accordianContentOuter').children('.accordianContent').slideDown();
          $(this).parent('li').addClass('active');
          $('.left-accordion-with-content-and-image .image-section').html($(this).parent('li').children('.js-accordian-img').children('article').html());
          if (scrollType !== 'Off') {
            var accordianHead = $(this);
            setTimeout(function () {
              var pos = accordianHead.offset().top - 110;
              $('body, html').animate({
                scrollTop: pos
              });
            }, 500);
          }
        } else {
          $('.accordian li').removeClass('active');
          $('.accordian li').children('.accordianContentOuter').children('.accordianContent').slideUp();
          $(this).parent('li').children('.accordianContentOuter').children('.accordianContent').slideUp();
          $(this).parent('li').removeClass('active');
        }
      });
      /* Partners Popup carousel  */
      var $partnersCarousel = $('.partnersPopupCarousel').owlCarousel({
        loop: true,
        margin: 0,
        nav: true,
        mouseDrag: false,
        touchDrag: false,
        dots: false,
        autoplay: false,
        autoplayTimeout: 5000,
        autoHeight: true,
        items: 1,
        URLhashListener: true,
        startPosition: 'URLHash'
      });

      /* Click of Search Result type */
      $('.js-search-resource-type').click(function () {
        var type = $(this).html().toLowerCase().trim();
        window.location.href = "/search-results/".concat(type);
      });

      /* Click of Search Result other */
      $('.js-search-content-type').click(function () {
        var type = $(this).html().toLowerCase().trim();
        /* checking if newsroom then change url */
        if (type === 'press and news') {
          window.location.href = '/search-results/*/content_type_news';
        } else {
          window.location.href = "/search-results/*/".concat(type);
        }
      });

      /*
        COMPANY CUSTOMER LANDING PAGE
        - click for the industry list in the drop down
         */
      /* on PAGE LOAD
        Update the text for the title to View All in Customer Success Stories */
      if ($('.js-update-view-all-anchor-url').length > 0) {
        $('.js-update-view-all-anchor-url a').text('View All');
        /* Update the URL from resources to company/customer */
        $('.js-update-view-all-anchor-url').each(function () {
          var anchorURL = $(this).children('a').attr('href');
          if (anchorURL) {
            //  console.log(anchorURL);
            /* replace resources with company/customers */
            anchorURL = anchorURL.replace('resources', 'company/customers');
            $(this).children('a').attr('href', anchorURL);
          }
        });
      } else {
        $('.js-update-view-all-anchor-url a').hide();
      }
      // $(".js-update-view-all-anchor-url").length > 0
      //   ? $(".js-update-view-all-anchor-url a").text("View All")
      //   : $(".js-update-view-all-anchor-url a").hide();
      /*
        on PAGE LOAD - change the URL for all the View ALL
        -------This might not being used
         */
      // $(".js-update-view-all-anchor-url").each(function(idx) {
      //   if ($(this).attr('href') === "#") {
      //     $(this).removeClass('whateverClass');
      //   }
      // });

      $('.heading-block-with-button').each(function () {
        var datatype = $(this).children('.contentWrapper-1290').children('h2').attr('data-type-industry');
        datatype = datatype.replace(/ /g, '-');
        $(this).children('.contentWrapper-1290').children('h2').attr('data-type-industry', datatype);
      });
      /* Scroll to section */
      /* Product categary second menu click and scroll to section */
      $('.scroll-move a').click(function (e) {
        e.preventDefault();
        var sectionPosition = $(this).attr('href');
        // $("html, body").animate({ scrollTop: 0 }, "slow");
        $('html, body').stop().animate({
          scrollTop: $(sectionPosition).offset().top - 150
        }, 1000, 'linear');
      });
      /* Product Category Template just for 2 types of URL's update the values */
      var productCategoryTemplate = window.location.href.toLowerCase().split('/');
      if (productCategoryTemplate.length === 5) {
        if (productCategoryTemplate[4] === 'analytics-and-industrial-iot' || productCategoryTemplate[4] === 'cloud-infrastructure') {
          $('.pcat-capabilities-li').hide();
        }
      }
      /* Update the text for the title to View All in Customer Success Stories */
      if ($('.js-update-text').length > 0) {
        $('.js-update-text a').text('View All');
      } else {
        $('.js-update-text a').hide();
      }
    }
  };
})(jQuery, Drupal);